import { ProfileQueryWrapper } from "./components/ProfileQueryWrapper";

export const ProfileScreen = () => <ProfileQueryWrapper />;
